import React, { useEffect, useState } from 'react';

import Icon from 'components/Icon';
import Typography from 'components/ui/Typography';

import css from './Collapse.module.scss';

interface Props extends React.PropsWithChildren {
    label: string;
    opened?: boolean;
}

const Collapse: React.FC<Props> = ({ label, children, opened = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(opened);
    }, [opened]);

    return (
        <div className={css.collapse}>
            <div className={css.label} onClick={() => setIsOpen(!isOpen)}>
                <Typography color="gray2">{label}</Typography>
                <Icon name={isOpen ? 'arrow-up' : 'arrow-down'} color="gray3" width={12} />
            </div>
            {isOpen && <div className={css.collapseContent}>{children}</div>}
        </div>
    );
};

export default React.memo(Collapse);
